// frontend/src/components/TagFilterChips.jsx
import React from "react";
import PropTypes from "prop-types";

/**
 * TagFilterChips — multi-select tag filter row (P14-G8).
 *
 * Each tag is a toggle chip; selecting several narrows the list to codes that
 * carry ALL of them (the backend's AND semantics). Renders nothing when the
 * org has no tags.
 *
 * @param {object}   props
 * @param {Array}    props.tags        All org tags ({id, name, color_hex})
 * @param {string[]} props.selectedIds Currently active tag ids
 * @param {Function} props.onToggle    (tagId) => void
 * @param {Function} props.onClear     () => void — clear all selections
 */
function TagFilterChips({ tags, selectedIds, onToggle, onClear }) {
  if (!tags.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-gray-400">Tags:</span>
      {tags.map((tag) => {
        const active = selectedIds.includes(tag.id);
        return (
          <button
            key={tag.id}
            type="button"
            onClick={() => onToggle(tag.id)}
            aria-pressed={active}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${
              active
                ? "text-white border-transparent"
                : "text-gray-600 bg-white border-gray-300 hover:bg-gray-50"
            }`}
            style={active ? { backgroundColor: tag.color_hex } : undefined}
          >
            <span
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: active ? "#fff" : tag.color_hex }}
            />
            {tag.name}
          </button>
        );
      })}
      {selectedIds.length > 0 && (
        <button
          type="button"
          onClick={onClear}
          className="text-xs text-gray-400 hover:text-gray-700 underline"
        >
          Clear
        </button>
      )}
    </div>
  );
}

TagFilterChips.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default TagFilterChips;
